import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import AddNewConstituentConfig from '@/constants/constituents/AddNewConstituentConfig';
import translate from '@/lib/intl/translate';

function AddNewConstituentModalContent({ handleClose }) {
  const history = useHistory();

  const onCardClick = (path) => {
    handleClose();
    history.push(path);
  };

  const config = AddNewConstituentConfig;

  const Cards = useMemo(
    () =>
      config.map(({ iconSrc, label, path }, idx) => (
        <button
          className={`flex h-40 w-full items-center justify-center rounded-lg border border-solid border-grey-300 hover:border-tertiary-main md:w-1/2 ${
            idx === 0 ? 'mb-6 md:mb-0 md:mr-10' : ''
          }`}
          data-testid={`${label}-card`}
          idx={`${idx}`}
          key={label}
          type="button"
          onClick={() => onCardClick(path)}
        >
          <div className="flex flex-col items-center">
            <img alt={label} className="mb-6 h-16 w-16" src={iconSrc} />
            <Typography>{label}</Typography>
          </div>
        </button>
      )),
    [history],
  );

  return (
    <>
      <div className="flex items-center justify-between p-6 pb-4.5">
        <div className="text-xl font-semibold">
          {translate('CONSTITUENTS_ADD_CONSTITUENT_LABEL')}
        </div>

        <Link data-testid="close" onClick={handleClose}>
          {translate('CANCEL')}
        </Link>
      </div>
      <div className="flex flex-col justify-between px-6 pb-6 md:flex-row">
        {Cards}
      </div>
    </>
  );
}

AddNewConstituentModalContent.propTypes = {
  handleClose: PropTypes.func,
};

AddNewConstituentModalContent.defaultProps = {
  handleClose: () => {},
};

export default AddNewConstituentModalContent;
